<template>
  <div class="handOverPage">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        :value="
          baseInput.applicantIdName
            ? baseInput.applicantIdName
            : baseInput.applicantName
        "
        v-if="mode != 'add'"
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
      <van-field
        v-model="userinfo.realName"
        v-else
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        v-model="baseInput.transferProjectName"
        :required="editType"
        readonly
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        label="需要的移交项目："
        class="ggInput"
        @click="showProjectPicker('1')"
      />
    </van-cell-group>
    <div class="claimDetailMain">
      <p class="fgx"></p>
      <p class="tit">
        关联报销明细 <span v-if="editType">（请至少添加一条）</span>
      </p>
      <van-cell-group class="claimDetailBox">
        <div class="claimDetailLists" v-if="reimburseList[0]">
          <div
            class="claimItem"
            v-for="(item, index) in reimburseList"
            :key="index"
          >
            <van-cell-group class="baseNone baseSalary">
              <van-field
                v-model="item.totalAmount"
                clearable
                type="number"
                v-enterIntNumber
                readonly
                class="ggInput"
                input-align="right"
                label="报销金额："
              />
            </van-cell-group>
            <van-cell-group class="baseNone baseSalary beizhu">
              <van-field
                v-model="item.applicantIdName"
                readonly
                :required="editType"
                label="报销人："
                class="ggInput"
                input-align="right"
              />
            </van-cell-group>
            <van-cell-group class="baseNone baseSalary beizhu">
              <van-field
                v-model="item.createTime"
                readonly
                :required="editType"
                label="报销时间："
                class="ggInput"
                input-align="right"
              />
            </van-cell-group>
            <div class="delect" v-if="reimburseList[0] && editType">
              <van-icon name="cross" @click="delect(item, index)" />
            </div>
          </div>
        </div>
        <div class="addBtn" v-if="editType">
          <van-button
            icon="plus"
            type="primary"
            class="addClaim"
            size="small"
            @click="addClaim"
            >添加报销明细</van-button
          >
        </div>
      </van-cell-group>
    </div>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        v-model="baseInput.projectName"
        :required="editType"
        readonly
        :is-link="editType"
        :placeholder="editType ? '请选择' : ''"
        label="接收的项目："
        class="ggInput"
        @click="showProjectPicker('2')"
      />
    </van-cell-group>
    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="baseInput.reason"
        rows="1"
        autosize
        :required="editType"
        label="变更原因"
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>
    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="this.mode != 'add' && baseInput.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="baseInput"></audit-list>
    </div>

    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="this.mode != 'add' && baseInput.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="baseInput"></flow-staff>
      <flow-list :workflowCode="baseInput.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main
        :applicantData="baseInput"
        @changeVerifyType="setVerifyType"
      ></verify-main>
    </van-popup>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="baseInput.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              class="btn"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              class="btn"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="baseInput.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        baseInput.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        class="btn"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          baseInput.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          baseInput.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>

    <!-- 弹框 -->
    <!-- 项目列表 -->
    <van-popup
      v-model="showProjrctListPicker"
      position="bottom"
      class="projectPicker"
    >
      <van-search
        v-model="searchProjrctKey"
        class="searchBox"
        id="searchHeight"
        placeholder="请输入项目名称 / 部门经理名称"
        shape="round"
        @input="onSearch"
      />
      <div class="projectListBox">
        <van-list
          v-model="itemLoading"
          :finished="itemFinished"
          finished-text="没有更多了"
          @load="getProjectList"
        >
          <van-radio-group v-model="radioItem">
            <van-cell-group class="baseNone baseSalary">
              <van-cell
                :title="`${
                  projectItem.projectYear + '年-' + projectItem.projectName
                }`"
                clickable
                v-for="projectItem in projectList"
                :key="projectItem.id"
                @click="selectitem(projectItem)"
              >
                <van-radio
                  slot="right-icon"
                  :name="`${projectItem.projectName}`"
                />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </van-list>
      </div>
      <div class="selectBtn clearfix">
        <a href="javascript:void(0);" class="fl" @click="closeProject">取消</a>
        <a href="javascript:void(0);" class="fl" @click="saveProject(listType)"
          >确认</a
        >
      </div>
    </van-popup>

    <!-- 弹出层：报销列表管理 -->
    <van-popup
      v-model="showBxPicker"
      position="bottom"
      class="roleBox bxPicker"
      @close="closeBxPicker"
    >
      <van-search
        v-model="applicantIdName"
        class="searchBox"
        id="searchHeight"
        placeholder="请输入报销人名称"
        shape="round"
        @input="onBxSearch"
      />
      <div class="projectListBox">
        <van-list
          v-model="bxItemLoading"
          :finished="bxItemFinished"
          finished-text="没有更多了"
        >
          <div
            v-for="(item, index) in bxBaseList"
            :key="index"
            :class="['bxMoreItem', item.isChecked ? 'selectVal' : '']"
            @click="moreSelectBx(item, index)"
          >
            <p><span>报销人：</span>{{ item.applicantIdName }}</p>
            <p><span>报销金额：</span>{{ item.totalAmount }}元</p>
            <p><span>报销时间：</span>{{ item.createTime }}</p>
            <p class="selected" v-if="item.isChecked">
              <van-icon name="success" />
            </p>
          </div>
        </van-list>
      </div>
      <div class="selectBtn clearfix">
        <a href="javascript:void(0);" class="fl" @click="closeBxPicker">取消</a>
        <a href="javascript:void(0);" class="fl" @click="saveBx">确认</a>
      </div>
    </van-popup>
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");

import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "reimbursementHandOver",
  components: {
    refreshPage,
    fileView,
    wxFileView,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      baseInput: {
        applicantId: "", //申请人id
        applicantName: "", //申请人姓名
        projectName: "", //接收项目名称
        projectId: "", //接收项目id
        transferProjectId: "", //移交项目id
        transferProjectName: "", //移交项目名称
        reimburseIds: [],
        reason: "",
        verifyStatus: "hold",
      },
      mode: "add",
      commonId: "", //编辑Id
      editType: false, //当前表单是否可以编辑
      projectYear: "",
      pageSize: 99, //pageSize
      showProjrctListPicker: false, //项目类型弹框
      itempage: 0, //项目列表page
      itemTotal: 0, //项目总条数
      itemLoading: true, //是否处于加载状态
      itemFinished: false, //是否已加载完所有数据
      listType: "1", //1:移交项目列表  2:接收项目列表
      undertakeType: "gsgl", // gsgl:公司管理 xmcj:项目承接
      searchProjrctKey: "",
      radioItem: "",
      itemMainList: [],
      checkedItemData: {},
      projectList: [],
      showBxPicker: false, //是否显示报销弹框
      bxPageNum: 0, //报销pageNum
      bxItemTotal: 0, //报销总条数
      bxItemLoading: true, //是否处于加载状态
      bxItemFinished: false, //是否已加载完所有数据
      applicantIdName: "", //报销人名称
      bxMainList: [],
      reimburseList: [],
      bxResult: [], //已经选择的报销
      bxBaseList: [], //项目下的所有报销
      bxSelectList: [], //选中的报销列表

      verifyPageType: false, //审批弹框,默认不显示
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      refreshPage: false, // 网络请求失败时显示
      sendType: "", //判断是否在抄送列表
      clientType: getDeviceType(), //手机类型
      is_weixn: is_wei(), //是否为微信
    };
  },
  mounted() {
    if (is_wei()) {
      document.title = "报销移交";
    }
    window.editPage = this.editPage; //编辑页面
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑 verify 审批
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.editType = this.mode == "add" ? true : false;

    this.$nextTick(() => {
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      if (this.mode == "edit" || this.mode == "verify" || this.mode == "view") {
        this.getDetails();
      } else {
        this.setShowLoad(false);
      }
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //app调用编辑
      this.editType = true;
    },
    verifyPage() {
      //app调用审批
      this.verifyPageType = true;
    },
    // 撤回和删除
    delApply() {
      let _this = this;
      let text = this.baseInput.verifyStatus == "hold" ? "删除" : "撤回";
      this.$dialog
        .alert({
          title: text,
          message: "你确定" + text + "吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.finance.transfer
            .deleteTransfer(this.baseInput.verifyStatus, _this.baseInput.id)
            .then((res) => {
              if (res.code == "1") {
                let msg = text + "操作成功";
                closePage(msg);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              console.log(err);
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
    /*获取详情*/
    getDetails() {
      let _this = this;
      _this.setShowLoad(false); //加载状态，默认为true加载
      _this.$api.finance.transfer
        .detail(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseInput = newApi.assign({}, _this.baseInput, res.data);
            _this.projectYear = res.data.projectYear ? res.data.projectYear : "";
            if (_this.baseInput.remarks == null) {
              _this.$set(_this.baseInput, "remarks", "");
            }
            _this.reimburseList = res.data.reimburseList;
            _this.bxSelectList = res.data.reimburseList;
            if (
              (_this.baseInput.verifyStatus == "hold" ||
                _this.baseInput.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //项目列表相关
    onSearch() {
      let _this = this;
      _this.itempage = 0;
      _this.itemLoading = true; //是否处于加载状态
      _this.itemFinished = false; //是否已加载完所有数据
      _this.projectList = [];
      _this.getProjectList();
    },
    getProjectList() {
      //获取项目列表
      let _this = this;
      if (
        _this.itempage != 0 &&
        _this.itempage * _this.pageSize >= parseInt(_this.itemTotal)
      ) {
        return;
      }
      _this.itempage += 1;
      _this.$api.finance.transfer
        .getProjectList(_this.itempage, _this.pageSize, {
          keyValues: _this.searchProjrctKey,
          listType: _this.listType,
          undertakeType: _this.undertakeType,
          projectYear: _this.listType == "2" ? _this.projectYear : "",
        })
        .then((res) => {
          if (res.code == "1") {
            _this.itemTotal = parseInt(res.data.total);
            _this.itemMainList = res.data.list;
            _this.viewItemLists();
            // 加载状态结束
            this.itemLoading = false;
            if (_this.itempage * _this.pageSize >= _this.itemTotal) {
              _this.itemFinished = true;
              console.log("加载完成");
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.itemFinished = true;
          console.log(err);
        });
    },
    viewItemLists() {
      this.projectList = this.projectList.concat(this.itemMainList);
    },
    selectitem(item) {
      let _this = this;
      _this.radioItem = item.projectName;
      _this.checkedItemData.id = item.id;
      _this.checkedItemData.projectName = item.projectName;
      _this.checkedItemData.projectYear = item.projectYear;
    },
    showProjectPicker(type) {
      if (this.editType) {
        this.radioItem = "";
        if (type == "1") {
          this.listType = "1";
          this.undertakeType = "";
        } else {
          if (this.baseInput.transferProjectId) {
            this.listType = "2";
            this.undertakeType = "xmcj";
          } else {
            this.$toast("请选择移交项目");
            return;
          }
        }
        this.onSearch();
        this.showProjrctListPicker = true;
      }
    },
    /*关闭项目类型数据 */
    closeProject() {
      this.showProjrctListPicker = false;
    },
    /*保存项目类型数据*/
    saveProject() {
      let _this = this;
      if (_this.checkedItemData.projectName) {
        _this.showProjrctListPicker = false;
        console.log(_this.checkedItemData, "checkedItemData");
        if (_this.listType == "1") {
          _this.baseInput.transferProjectName =
            _this.checkedItemData.projectName;
          _this.baseInput.transferProjectId = _this.checkedItemData.id;
          _this.projectYear = _this.checkedItemData.projectYear;
          _this.reimburseList = [];
          _this.bxResult = []; //已经选择的报销
          _this.bxBaseList = []; //项目下的所有报销
          _this.bxSelectList = []; //选中的报销列表
          _this.bxPageNum = 0; //报销pageNum
          _this.bxItemTotal = 0; //报销总条数
          _this.searchProjrctKey = "";
          _this.bxItemLoading = true; //是否处于加载状态
          _this.bxItemFinished = false; //是否已加载完所有数据
          console.log(_this.baseInput, "baseInput");
        } else {
          _this.baseInput.projectName = _this.checkedItemData.projectName;
          _this.baseInput.projectId = _this.checkedItemData.id;
        }
      } else {
        _this.$toast("请选择一个项目");
      }
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    //报销相关
    addClaim() {
      //选择报销
      if (this.editType) {
        if (this.baseInput.transferProjectId) {
          console.log(1111);
          this.getBxList();

          this.showBxPicker = true;
        } else {
          this.$toast("请先选择需要的移交项目");
        }
      }
    },
    onBxSearch() {
      let _this = this;
      _this.bxPageNum = 0;
      _this.bxItemTotal = 0; //报销总条数
      _this.bxItemLoading = true; //是否处于加载状态
      _this.bxItemFinished = false; //是否已加载完所有数据
      _this.bxBaseList = [];

      this.getBxList();
    },
    getBxList() {
      //获取报销列表
      let _this = this;
      if (
        _this.bxPageNum != 0 &&
        _this.bxPageNum * _this.pageSize >= parseInt(_this.bxItemTotal)
      ) {
        return;
      }
      _this.bxPageNum += 1;
      _this.$api.finance.transfer
        .getReimbureList(_this.bxPageNum, _this.pageSize, {
          applicantIdName: _this.applicantIdName,
          projectId: _this.baseInput.transferProjectId,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.bxItemTotal = parseInt(res.data.total);
            _this.bxMainList = res.data.list;
            _this.viewBxItemLists();
            // 加载状态结束
            this.bxItemLoading = false;
            if (_this.bxPageNum * _this.pageSize >= _this.bxItemTotal) {
              _this.bxItemFinished = true;
              console.log("加载完成");
            } else {
              _this.getBxList();
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.bxItemFinished = true;
          console.log(err);
        });
    },
    viewBxItemLists() {
      let _this = this;
      _this.bxBaseList = _this.bxBaseList.concat(_this.bxMainList);

      _this.bxBaseList.map(function (item) {
        _this.$set(item, "isChecked", false);
      });

      if (_this.bxSelectList[0]) {
        _this.bxSelectList.forEach((selectItem) => {
          _this.bxBaseList.forEach((item) => {
            if (selectItem.id == item.id) {
              this.$set(item, "isChecked", !item.isChecked);
            }
          });
        });
      }
    },
    moreSelectBx(item) {
      let _this = this;
      if (_this.bxSelectList[0]) {
        console.log(_this.bxSelectList, "zongji");
        let index = _this.bxSelectList.findIndex(
          (selectItem) => selectItem.id == item.id
        );
        console.log(index);
        if (index < 0) {
          _this.bxSelectList.push(item);
        } else {
          _this.bxSelectList.forEach((selectVal, selectIndex) => {
            if (selectVal.id == item.id) {
              _this.bxSelectList.splice(selectIndex, 1);
            }
          });
        }
      } else {
        _this.bxSelectList.push(item);
      }
      this.$set(item, "isChecked", !item.isChecked);
    },
    closeBxPicker() {
      //项目报销关闭弹出框
      this.showBxPicker = false;
    },
    saveBx() {
      //项目报销确认选择
      let _this = this;
      _this.reimburseList = [];
      if (_this.bxSelectList[0]) {
        _this.showBxPicker = false;
        _this.reimburseList = _this.bxSelectList;
      } else {
        this.$toast("请选择关联的报销");
      }
    },
    delect(item, index) {
      //删除报销
      let _this = this;
      _this.reimburseList.splice(index, 1);
      if (_this.bxSelectList[0]) {
        _this.bxSelectList.forEach((selectVal, selectIndex) => {
          if (selectVal.id == item.id) {
            _this.bxSelectList.splice(selectIndex, 1);
          }
        });
      }
      _this.$set(item, "isChecked", !item.isChecked);
    },

    //提交校验
    checkInput() {
      let _this = this;
      console.log(this.baseInput);
      _this.baseInput.reimburseIds = [];
      if (
        _this.baseInput.projectId == "" ||
        _this.baseInput.reason == "" ||
        _this.baseInput.transferProjectId == "" ||
        !_this.reimburseList[0]
      ) {
        this.$toast("带星号为必填项，不能为空");
      } else {
        _this.reimburseList.forEach((item) => {
          _this.baseInput.reimburseIds.push(item.id);
        });
        _this.submitMain();
      }
    },
    //保存
    submitMain() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.finance.transfer
        .update(this.mode, _this.baseInput)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
  },

  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.handOverPage {
  width: 100%;
  min-height: 100%;
  background-color: #f6f6f6;
  padding-bottom: 60px;

  .searchBox {
    padding: 0 8px;
    margin-bottom: 10px;
  }
  //项目 报销
  .projectPicker,
  .bxPicker {
    width: 100%;
    height: 70%;
    padding-top: 10px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    .projectListBox {
      width: 100%;
      height: calc(100% - 100px);
      overflow-y: scroll;
    }
    .selectBtn {
      z-index: 9999;
      position: fixed;
      width: 100%;
      font-size: 15px;
      text-align: center;
      color: #333;
      height: 45px;
      border-top: 1px solid #f6f6f6;
      bottom: 0;
      z-index: 999;
      background-color: #fff;

      a:first-child {
        color: rgb(235, 199, 155);
        border-right: 1px solid #f6f6f6;
        // background-color: rgb(235, 199, 155);
      }
      a {
        display: inline-block;
        width: 50%;
        height: 100%;
        line-height: 45px;
        color: #07c160;
        // background-color: #07c160;
        font-size: 15px;
        box-sizing: border-box;
      }
    }
  }
  .bxPicker {
    .projectListBox {
      padding: 0 16px;
      .bxMoreItem {
        padding: 5px;
        border-radius: 5px;
        border: 1px solid #f6f6f6;
        margin: 10px 0;
        position: relative;
        overflow: hidden;
        p {
          margin: 5px 0;
          font-size: 15px;
          color: #969799;
          span {
            color: #323233;
          }
        }
        .selected {
          width: 40px;
          height: 70px;
          background-color: #2581d6;
          color: #fff;

          position: absolute;
          transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
          top: -35px;
          right: -15px;
          font-size: 20px;
          .van-icon-success {
            position: absolute;
            top: 25px;
            left: 0;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
          }
        }
      }
      .bxMoreItem.selectVal {
        border: 1px solid #2581d6;
      }
    }
  }
  .baseNone {
    .van-cell__title {
      span {
        color: #323233;
      }
    }
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 160px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  //添加明细样式
  .claimDetailMain {
    background-color: #fff;
    .fgx {
      width: 100%;
      height: 10px;
      background-color: #f6f6f6;
    }
    p.tit {
      position: relative;
      padding: 0 16px 0 25px;
      font-size: 15px;
      height: 45px;
      line-height: 45px;
      position: relative;
      color: #2581d6;
      font-weight: 700;
      border-bottom: 1px solid #f6f6f6;
      span {
        font-size: 12px;
        color: red, //#333;;
      }
    }
    p.tit:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 20px;
      background: #2581d6;
      top: 13px;
      left: 16px;
    }
    .baseNone::after {
      content: none;
    }
    .claimDetailBox {
      width: 100%;
      padding-bottom: 10px;
      .claimDetailLists {
        width: 95%;
        margin: 0 auto;
        min-height: 140px;
        padding: 0 8px;
        .claimItem {
          box-sizing: border-box;
          margin-top: 10px;
          border: 1px solid #f1f1f1;
          border-radius: 8px;
          position: relative;
          .delect {
            text-align: center;
            position: absolute;
            top: -6px;
            right: -4px;
            width: 20px;
            height: 20px;
            line-height: 20px;
            border-radius: 50%;
            background: #fff;
            border: 1px solid red;
            color: red;
            cursor: pointer;
            padding-top: 1px;
          }
        }
      }
      .addBtn {
        margin-top: 10px;
        width: 100%;
        .addClaim {
          display: block;
          margin: 0 auto;
          border-radius: 8px;
          -webkit-border-radius: 8px;
          -moz-border-radius: 8px;
        }
      }
    }
    .claimDetailBox.van-cell-group.van-hairline--top-bottom::after {
      content: none;
    }
  }

  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
}
</style>